import MyFooter from '../components/commoncomponents/MyFooter.tsx';
import MyHeader from '../components/commoncomponents/MyHeader.tsx';
import HomePage from '../pages/HomePage.tsx';

export const HP = () => {

    return (
        <>
            <MyHeader />
            <HomePage />
            <MyFooter />
        </>
    )
}